<template>
  <div class="hkl-invite">
    <HKLModal
      ref="modal"
      :title="$t('hint.inviteAllUsers')"
      okBtnAction="yesInvite"
      @onOkClick="inviteClick"
    >
      <div>
        {{ listTitle }}
      </div>
      <ul>
        <li
          v-for="account in accountsList"
          :key="account.id"
        >
          {{ account.username }}
        </li>
      </ul>
    </HKLModal>
  </div>
</template>

<script>
import { computed } from 'vue-demi'
import HKLModal from '@/controls/Modal/HKLModal'
import { useRefModal } from '@/controls/Modal/modal.hook'

export default {
  components: {
    HKLModal,
  },
  props: {
    accountsList: {
      type: Array,
      default: () => [],
    },
    onInviteClick: {
      type: Function,
      default: undefined,
    },
    listTitle: {
      type: String,
      default: '',
    },
  },
  setup (props, { emit }) {
    const { open, modal, close } = useRefModal()
    const inviteClick = computed(() => (props.onInviteClick || function () { emit('onInviteClick') }))
    return {
      open,
      close,
      modal,
      inviteClick,
    }
  },

}
</script>
